import {Site, User} from '../../users/models';

export class AuthState {
  token: string;
  expires: number;
  user: User;
  site: Site;
}
